import Loadable from '../../components/loadable';
import ModalPlaceholder from '../../components/modal_placeholder';

const DeactivateRecurringBookingsModal = Loadable({
  loader: () => import('../../pages/contacts/deactivate_recurring_bookings_modal'),
  loading: ModalPlaceholder,
});

angular.module('gym').value('DeactivateRecurringBookingsModal', DeactivateRecurringBookingsModal);
